import { render, staticRenderFns } from "./PasswordlessLogin.vue?vue&type=template&id=3adc687c&scoped=true"
import script from "./PasswordlessLogin.vue?vue&type=script&lang=js"
export * from "./PasswordlessLogin.vue?vue&type=script&lang=js"
import style0 from "./PasswordlessLogin.vue?vue&type=style&index=0&id=3adc687c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc687c",
  null
  
)

export default component.exports